export default __webpack_public_path__ + "static/Plots0003-07ad517c8cb42ac42cd61a9a5ef6d50b.jpg";